module.exports = __webpack_public_path__ + "img/Logo.4e83694b.svg";